<template>
  <!-- Redesign — the assistant's live sign: the brand compass. Idle, it rests;
       working, its needle turns slowly; done and not yet seen, the needle rests
       and a small indigo dot waits on the ring. Reduced motion: the needle
       breathes instead of turning. -->
  <svg :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" focusable="false" class="activity-compass">
    <circle cx="12" cy="12" r="8.5" fill="none" :stroke="ringColor" stroke-width="2.4" />
    <path v-if="!muted" d="M16.8 4.6a9.6 9.6 0 0 1 3 3.4" fill="none" stroke="#74F2CE" stroke-width="2.4" stroke-linecap="round" />
    <g :class="{ turning: state === 'working' }">
      <path d="M9 15l2-4 4-2-2 4z" fill="var(--p-primary-color)" />
    </g>
    <circle v-if="state === 'done'" cx="20" cy="4" r="3.4" fill="var(--p-primary-color)" stroke="#ffffff" stroke-width="1.6" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  state: 'idle' | 'working' | 'done'
  size?: number
  /** A quieter ring, for small places (the project rail). */
  muted?: boolean
}>(), { size: 22, muted: false })

const ringColor = computed(() => (props.muted ? 'var(--p-surface-300)' : 'var(--p-primary-color)'))
</script>

<style scoped>
.activity-compass { flex-shrink: 0; }
.turning { transform-origin: 12px 12px; animation: compass-turn 3.2s linear infinite; }
@keyframes compass-turn { to { transform: rotate(360deg); } }
@keyframes compass-breathe { 50% { opacity: 0.35; } }
@media (prefers-reduced-motion: reduce) {
  .turning { animation: compass-breathe 2s ease-in-out infinite; }
}
</style>
